import { render } from "./RwsUserSetup.vue?vue&type=template&id=2203af1d"
import script from "./RwsUserSetup.vue?vue&type=script&lang=js"
export * from "./RwsUserSetup.vue?vue&type=script&lang=js"

import exportComponent from "/home/vol4/node/projects/robonomics/robonomics-dapp-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__